import * as Sentry from '@sentry/react-native'
import AppConfig from 'config'
import { isRunningInExpoGo } from 'expo'

// Construct a new instrumentation instance. This is needed to communicate between the integration and React
export const routingInstrumentation = Sentry.reactNavigationIntegration({
  enableTimeToInitialDisplay: !isRunningInExpoGo(),
})

if (AppConfig.sentry.enabled) {
  Sentry.init({
    dsn: 'https://0b22bfa9a5331369fcf8a380d173b600@sentry.supervista.net/6',
    enableNativeFramesTracking: !isRunningInExpoGo(),
    debug: true, // If `true`, Sentry will try to print out useful debugging information if something goes wrong with sending the event. Set it to `false` in production
    integrations: [routingInstrumentation],
  })
}
